import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Arrow from "../../assest/arrow.png";

const AboutUsSection = ({
  heading: propHeading,
  buttonText: propButtonText,
  language: propLanguage,
  onButtonClick,
}) => {
  const navigate = useNavigate();
  const reduxLanguage = useSelector((state) => state.language.language);
  const language = propLanguage || reduxLanguage || "gb";

  const translations = {
    gb: {
      heading: "About Us",
      buttonText: "Get In Touch",
    },
    sa: {
      heading: "معلومات عنا",
      buttonText: "تواصل معنا",
    },
    fr: {
      heading: "À propos de nous",
      buttonText: "Contactez-nous",
    },
    de: {
      heading: "Über uns",
      buttonText: "Kontaktieren Sie uns",
    },
  };

  const t = translations[language] || translations.gb;

  const heading = propHeading || t.heading;
  const buttonText = propButtonText || t.buttonText;

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      navigate("/contact");
    }
  };

  return (
    <section
      className="d-flex justify-content-center align-items-center text-center py-5"
      style={{
        minHeight: "40vh",
        background: "radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)",
      }}
    >
      <div className="container px-3">
        <h1 className="fw-bold display-4 display-md-3 display-lg-2 mb-4">{heading}</h1>

        <button
          onClick={handleButtonClick} 
          className="btn btn-danger mt-3 d-inline-flex align-items-center justify-content-center rounded-pill px-3 px-md-4 py-1 py-md-2 fw-medium"
          style={{
            gap: "0.5rem",
            fontSize: "clamp(0.875rem, 1.25vw, 1.125rem)",
            transition: "all 0.3s ease",
          }}
        >
          {buttonText}
          <span
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "1.75em",
              height: "1.75em",
              padding: "0.25em",
              transition: "all 0.3s ease",
            }}
          >
            <img
              src={Arrow}
              alt=""
              style={{
                width: "20px",
                height: "20px",
                transition: "transform 0.3s ease",
              }}
              className="btn-arrow"
            />
          </span>
        </button>

        <style>{`
          .btn:hover .btn-arrow {
            transform: translateX(3px);
          }
          .btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }
        `}</style>
      </div>
    </section>
  );
};

export default AboutUsSection;